import { registerProvider } from './index';

class UmamiProvider {
  name = 'umami';
  websiteId = '';
  baseUrl = '';

  initialize(config) {
    this.websiteId = config?.website_id || '';
    this.baseUrl = config?.base_url || '';
    if (!this.websiteId) {
      console.warn('[analytics:umami] website_id not configured');
    }
  }

  async track(event, properties) {
    if (!this.websiteId) return;
    // Use Umami's official tracking API (loaded via script tag in index.html).
    // This ensures events share the same session as page views.
    if (typeof window !== 'undefined' && window.umami) {
      try {
        await window.umami.track(event, properties);
      } catch {
        // Analytics is best-effort; swallow errors
      }
    }
  }

  pageView(page, properties) {
    // Page views are auto-tracked by the Umami script tag.
    // Only track if explicitly called with extra properties.
    if (properties && Object.keys(properties).length > 0) {
      this.track('page_view', { ...properties, page });
    }
  }

  identify() {
    // Umami does not support user identification
  }

  revenue(event, amount, currency, properties) {
    this.track(event, { ...properties, amount, currency });
  }

  timing(page, durationMs) {
    this.track('page_time', { page, duration_ms: durationMs });
  }

  setConsent() {}
  flush() {}
  shutdown() {}
  reset() {}
  isHealthy() { return Boolean(this.websiteId); }
}

registerProvider('umami', UmamiProvider);
export default UmamiProvider;
